import Box from '@mui/material/Box';
import { FormattedMessage } from 'react-intl';
import Typography from '@mui/material/Typography';
import { PlanInterval } from '../../../models';
import SubProductItem, { SubProductItemProps } from './SubProductItem';
import ProductQuotaSelection from './ProductQuotaSelection';

export interface ProductItemProps {
  productId: string;
  unitPrice?: Partial<Record<PlanInterval, number>>;
  subProducts?: SubProductItemProps[];
  initQuota?: number;
  tooltipText? :string;
  disabled: boolean;
}

const ProductItem = (
  { productId, unitPrice, subProducts, initQuota, tooltipText, disabled }: ProductItemProps,
) => (
  <Box
    id={`product-item-${productId}-selection`}
    display="flex"
    paddingY={2}
    flexDirection="column"
  >
    <Box
      id={`product-item-${productId}-header`}
      width="100%"
      paddingRight={0}
    >
      <Typography
        variant="subtitle1"
        fontWeight={700}
        fontSize={19}
        color="#000000"
      >
        <FormattedMessage id={`page.expand.plan.product.${productId}.title`} />
      </Typography>
      <Typography
        variant="body1"
        fontWeight={400}
        fontSize={16}
      >
        <FormattedMessage id={`page.expand.plan.product.${productId}.desc`} />
      </Typography>
    </Box>
    {unitPrice && (
      <Box
        id={`product-item-${productId}-quota-selection`}
        display="flex"
        flexDirection="row"
        justifyContent="space-between"
        paddingTop={2}
        width="100%"
      >
        <ProductQuotaSelection
          productId={productId}
          price={unitPrice}
          initQuota={initQuota}
          tooltipText={tooltipText}
          disabled={disabled}
        />
      </Box>
    )}
    {subProducts && subProducts.length > 0 && (
      <Box
        id={`product-item-${productId}-sub-products`}
        display="flex"
        flexDirection="column"
      >
        {subProducts.map(subProduct => (
          <SubProductItem key={subProduct.subProductId} {...subProduct} disabled={disabled} />
        ))}
      </Box>
    )}
  </Box>
);

export default ProductItem;
